import { productsApi } from "./materialsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Product, CreateProduct, UpdateProduct, ProductRequest, ProductsWithLocations } from "./materials.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";

export const fetchProducts = createAsyncThunk<
  APIResponse<{page: number; size: number; total: number; totalPages: number; productos: Product[]}>,
  ProductRequest,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'products/fetchProducts',
  async (params: ProductRequest, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        productsApi.endpoints.getProducts.initiate(params)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener productos',
          details: data.details
        });
    }
  }
);


export const fetchProductById = createAsyncThunk<APIResponse<Product>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'products/fetchProductById',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        productsApi.endpoints.getProductsById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Producto por ID',
        details: data.details
      });
    }
  }
);


export const createProduct = createAsyncThunk<APIResponse<Product>, CreateProduct,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'products/createProduct',
  async (data: CreateProduct, { dispatch, rejectWithValue }) => {
    try {
      // Disparamos la mutación y esperamos el resultado
      const result = await dispatch(
        productsApi.endpoints.createProducts.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Producto',
        details: data.details
      });
    }
  }
);



export const updateProduct = createAsyncThunk<
  APIResponse<Product>,
   { id: number; changes: UpdateProduct }, 
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'products/updateProduct',
  async ({ id, changes  }, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        productsApi.endpoints.updateProducts.initiate({ id, changes  })
      ).unwrap();

      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al actualizar Producto',
        details: data.details
      });
    }
  }
);


export const deleteProduct = createAsyncThunk<
  number,
  number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'products/deleteProduct',
  async (id , { dispatch, rejectWithValue }) => {
    try {
      await dispatch(
        productsApi.endpoints.deleteProducts.initiate(id)
      ).unwrap();
      
      return id;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al eliminar Producto',
        details: data.details
      });
    }
  }
);



export const fetchProductUbications = createAsyncThunk<
  APIResponse<{page: number; size: number; total: number; totalPages: number; items: ProductsWithLocations[]}>,
  ProductRequest,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'products/fetchProductUbications',
  async (params: ProductRequest, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        productsApi.endpoints.getProductsUbications.initiate(params)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener productos con ubicaciones',
          details: data.details
        });
    }
  }
);
